/* global window */
export const updateContainer = selectedContainer => ({
  type: 'UPDATE_CONTAINER',
  selectedContainer,
});

export const updateLayout = selectedLayout => ({
  type: 'UPDATE_LAYOUT',
  selectedLayout,
});

export const updateArtboard = artboardKey => ({
  type: 'UPDATE_ARTBOARD',
  artboardKey,
});

export const updateDimensions = dimensions => ({
  type: 'UPDATE_DIMENSIONS',
  dimensions,
});

export const updateCanvasScale = scale => ({
  type: 'UPDATE_CANVAS_SCALE',
  scale,
});

export const toggleFitToScreen = () => ({
  type: 'TOGGLE_FIT_TO_SCREEN',
});

export const shouldChangeArtboard = (artboard) => {
  const { 'wve-api': api } = window;
  return api && api.shouldChangeArtboard(artboard);
};

export const shouldSetArtboard = (artboard) => {
  const { 'wve-api': api } = window;
  return api && api.shouldSetArtboard(artboard);
};

export const updateDevice = deviceKey => ({
  type: 'UPDATE_DEVICE',
  deviceKey,
});

export const toggleDeviceOrientation = () => ({
  type: 'TOGGLE_DEVICE_ORIENTATION',
});



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/actions/index.js